// extracted by mini-css-extract-plugin
module.exports = {"mentionContainer":"antd-pro-containers-template-styles-mentionContainer","focus":"antd-pro-containers-template-styles-focus"};